module.exports = __webpack_public_path__ + "static/media/awake-icon.06397015.svg";